import { type ProgramTaskCreateInput, type ProgramTaskCreateSuccess, type TaskData } from '@terros/common'
import { type AddHookResponse, mutationAdd } from '../hooks'
import { useTantalimMutation } from '../mutation'

export const useCreateProgramTasks = (): AddHookResponse<ProgramTaskCreateInput, TaskData[]> => {
  const mutation = useTantalimMutation<ProgramTaskCreateInput, ProgramTaskCreateSuccess>({
    url: '/program/task/create',
  })

  const create = async (input: ProgramTaskCreateInput): Promise<TaskData[]> => {
    const { tasks } = await mutation.mutateAsync(input)
    return tasks
  }

  return mutationAdd(mutation, create)
}
